import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Form, Input, Label, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Fecha de Registro",
        field: "fecha_str",
        sort: "asc"
    },
    {
        label: "Usuario",
        field: "username",
        sort: "asc"
    },
    {
        label: "Componente",
        field: "componente",
        sort: "asc"
    },
    {
        label: "Ruta",
        field: "ruta",
        sort: "asc"
    }   
];

const columns_agrupado = [
    {
        label: "Contador",
        field: "contador",
        sort: "asc"
    },
    {
        label: "Componente",
        field: "componente",
        sort: "asc"
    }  
];

export default class ReporteHistorialMenu extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        props = _valid(props, props.props) ? props.props : props;
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {},
            tabla: { columns: columns, rows: [] },
            tabla_agrupado: { columns: columns_agrupado, rows: [] },
            usuarioLista: [],
            estadoLista: [],
            consulta: {
                fecha_inicio: null,
                fecha_fin: null,
                usuario: null,
                estado: null,
                articulo_nombre: null,
                articulo_codigo: null,
            }
        };
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
    }

    componentDidMount() {
        this.obtenerUsuario();
    }

    obtenerUsuario() {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/usuario').then(resultado => {
                if (resultado.exitoso) {
                    const usuariosMapeados = resultado.data.map(usuario => ({
                        ...usuario, 
                        value: usuario.id, 
                        label: usuario.username 
                    }));
                    this.setState({ usuarioLista: usuariosMapeados });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } 
    }

    setUsuario = usuario => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['usuario']: usuario }
        }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, [name]: value }
        }));
    }

    buscar = async () => {
        const {
            consulta
        } = this.state

        if (this.verificar(consulta)) {
            this.apiRest.post('/reporteHistorialMenu', consulta).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tabla: { columns, rows: resultado.data } })

                    this.apiRest.post('/reporteHistorialMenuAgrupado', consulta).then(resultado => {
                        if (resultado.exitoso) {
                            this.setState({ tabla_agrupado: { columns: columns_agrupado, rows: resultado.data } })
                        } else {
                            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                        }
                    });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            this.apiRest.getRol() ?
            toastr.error('Seleccione un filtro por favor')
            :  toastr.error('Seleccione Modificado por')
        }
    }

    verificar = (data) => {
        let contador = 0;
        if(this.apiRest.getRol()){
            if (_valid(data.fecha_inicio)) {
                if (_valid(data.fecha_fin)) {
                    contador += 1;
                }
            } else if (_valid(data.usuario)) {
                contador += 1;
            } else if (_valid(data.estado)) {
                contador += 1;
            } else if (_valid(data.articulo_nombre)) {
                contador += 1;
            } else if (_valid(data.articulo_codigo)) {
                contador += 1;
            }
        }else{
            if(_valid(data.usuario)){
                contador = 1
            }
        }

        if (contador !== 0) {
            return true;
        } else {
            return false;
        }
    }

    validarDatos(filtro) {
        for (const property in filtro) {
            if (_valid(filtro[property])) {
                return true;
            }
        }
        return false;
    }

    borrarFiltros = () => {
        const {
            consulta
        } = this.state

        for (const property in consulta) {
            this.borrarEstado(property)
        }

        this.setState(estadoAnterior => ({
            tabla: {
                ...estadoAnterior.tabla, ['rows']: []
            }
        }));

        this.setState(estadoAnterior => ({
            tablaa_grupado: {
                ...estadoAnterior.tabla_agrupado, ['rows']: []
            }
        }));
    }

    borrarEstado(name) {
        this.setState(estadoAnterior => ({
            consulta: {
                ...estadoAnterior.consulta, [name]: ''
            }
        }));
    }

    render() {
        const {
            usuarioLista,
            consulta
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem={"Historial de Menú"} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="usuario" className="form-label">
                                                    Usuario
                                                </Label>
                                                <Select
                                                    name="usuario"
                                                    options={usuarioLista}
                                                    value={consulta.usuario}
                                                    onChange={this.setUsuario}
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="fecha_inicio" className="form-label">
                                                    Fecha Inicio
                                                </Label>
                                                <Input
                                                    name="fecha_inicio"
                                                    value={consulta.fecha_inicio}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                    className="form-control"
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="fecha_fin" className="form-label">
                                                    Fecha Fin
                                                </Label>
                                                <Input
                                                    name="fecha_fin"
                                                    value={consulta.fecha_fin}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>                                        
                                        <br />
                                        <Row>
                                            <Col>
                                                <MDBBtn className="waves-effect" color="primary" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                                {' '}
                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                    Borrar Filtros
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <br />
                                        <div className="p-4 border-top">
                                            <Form>
                                                <Row>
                                                    <Col lg={4}>
                                                        <Label>
                                                            Contador
                                                        </Label>
                                                        <div className="table-responsive">
                                                            <MDBDataTable hover searching={false} entries={10} searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla_agrupado} />
                                                        </div>
                                                    </Col>
                                                    <Col lg={1}></Col>
                                                    <Col lg={7}>
                                                        <Label>
                                                            Historial
                                                        </Label>
                                                        <div className="table-responsive">
                                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                        <br />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}